// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Existing Styles (Unchanged) --- */
.header {
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  background-color: #ffffff;
  border-bottom: 1px solid #f3f4f6;
  gap: 16px; /* Adds space between elements */
  justify-content: space-between;
}
.header-title h1 {
  font-size: 28px;
  font-weight: 600;
  color: #174078;
}
.header-controls {
  display: flex;
  align-items: center;
  gap: 25px;
}
.user-profile {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 4px;
  border-radius: 8px;
  transition: background-color 0.2s;
}
.user-profile:hover {
  background-color: #f3f4f6;
}
.user-profile .avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.user-profile .user-name {
  font-weight: 600;
  color: #111827;
}
.user-profile .chevron-down {
  width: 16px;
  height: 16px;
  transition: transform 0.2s;
}
.user-profile .chevron-down.open {
  transform: rotate(180deg);
}

/* === NEW STYLES FOR THE DROPDOWN === */
.user-profile-container {
  position: relative; /* This is the anchor for the dropdown */
}
.profile-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  top: 100%; /* Position it right below the user profile */
  right: 0;
  background-color: white;
  border: 1px solid #f3f4f6;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 180px;
  z-index: 1000;
  overflow: hidden; /* Ensures children respect the border-radius */
  animation: dropdown-fade-in 0.2s ease-out;
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.profile-dropdown ul {
  list-style: none;
  padding: 8px 0;
  margin: 0;
}
.profile-dropdown li {
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition:
    background-color 0.2s,
    color 0.2s;
}
.profile-dropdown li:hover {
  background-color: #fef3f2; /* Your brand's orange highlight color */
  color: #f97316;
}

/* === RESPONSIVE & MOBILE MENU STYLES === */

.mobile-menu-btn {
  display: none; /* Hidden on desktop by default */
  background: none;
  border: none;
  cursor: pointer;
  font-size: 28px; /* Make it a bit bigger and easier to tap */
  color: #174078;
  padding: 0;
  margin-right: 16px; /* Add some space between it and the title */
}

@media (max-width: 1024px) {
  .header {
    padding: 0 24px;
  }
}

@media (max-width: 768px) {
  /* On mobile, show the hamburger menu */
  .mobile-menu-btn {
    display: block;
  }

  /* Make the title take up the available space to center it */
  .header-title {
    flex-grow: 1;
    text-align: center;
    /* Optional: reduce font size on small screens */
    font-size: 22px;
  }
}

@media (max-width: 480px) {
  /* On very small screens, you might want to hide the user name */
  .user-profile .user-name,
  .user-profile .chevron-down {
    display: none;
  }
  .header-controls {
    gap: 16px; /* Reduce gap on small screens */
  }
}

.profile-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
}

.profile-trigger:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
`, "",{"version":3,"sources":["webpack://./src/compoonents/Header/Header.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,SAAS,EAAE,gCAAgC;EAC3C,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE,kBAAkB,EAAE,wCAAwC;AAC9D;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS,EAAE,6CAA6C;EACxD,QAAQ;EACR,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,aAAa;EACb,gBAAgB,EAAE,+CAA+C;EACjE,yCAAyC;AAC3C;AACA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf;;cAEY;AACd;AACA;EACE,yBAAyB,EAAE,wCAAwC;EACnE,cAAc;AAChB;;AAEA,4CAA4C;;AAE5C;EACE,aAAa,EAAE,iCAAiC;EAChD,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe,EAAE,2CAA2C;EAC5D,cAAc;EACd,UAAU;EACV,kBAAkB,EAAE,4CAA4C;AAClE;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,uCAAuC;EACvC;IACE,cAAc;EAChB;;EAEA,4DAA4D;EAC5D;IACE,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,eAAe;EACjB;AACF;;AAEA;EACE,gEAAgE;EAChE;;IAEE,aAAa;EACf;EACA;IACE,SAAS,EAAE,gCAAgC;EAC7C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":["/* --- Existing Styles (Unchanged) --- */\n.header {\n  height: 80px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 40px;\n  background-color: #ffffff;\n  border-bottom: 1px solid #f3f4f6;\n  gap: 16px; /* Adds space between elements */\n  justify-content: space-between;\n}\n.header-title h1 {\n  font-size: 28px;\n  font-weight: 600;\n  color: #174078;\n}\n.header-controls {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n}\n.user-profile {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 8px;\n  transition: background-color 0.2s;\n}\n.user-profile:hover {\n  background-color: #f3f4f6;\n}\n.user-profile .avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.user-profile .user-name {\n  font-weight: 600;\n  color: #111827;\n}\n.user-profile .chevron-down {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s;\n}\n.user-profile .chevron-down.open {\n  transform: rotate(180deg);\n}\n\n/* === NEW STYLES FOR THE DROPDOWN === */\n.user-profile-container {\n  position: relative; /* This is the anchor for the dropdown */\n}\n.profile-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  top: 100%; /* Position it right below the user profile */\n  right: 0;\n  background-color: white;\n  border: 1px solid #f3f4f6;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  width: 180px;\n  z-index: 1000;\n  overflow: hidden; /* Ensures children respect the border-radius */\n  animation: dropdown-fade-in 0.2s ease-out;\n}\n@keyframes dropdown-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.profile-dropdown ul {\n  list-style: none;\n  padding: 8px 0;\n  margin: 0;\n}\n.profile-dropdown li {\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  transition:\n    background-color 0.2s,\n    color 0.2s;\n}\n.profile-dropdown li:hover {\n  background-color: #fef3f2; /* Your brand's orange highlight color */\n  color: #f97316;\n}\n\n/* === RESPONSIVE & MOBILE MENU STYLES === */\n\n.mobile-menu-btn {\n  display: none; /* Hidden on desktop by default */\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 28px; /* Make it a bit bigger and easier to tap */\n  color: #174078;\n  padding: 0;\n  margin-right: 16px; /* Add some space between it and the title */\n}\n\n@media (max-width: 1024px) {\n  .header {\n    padding: 0 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  /* On mobile, show the hamburger menu */\n  .mobile-menu-btn {\n    display: block;\n  }\n\n  /* Make the title take up the available space to center it */\n  .header-title {\n    flex-grow: 1;\n    text-align: center;\n    /* Optional: reduce font size on small screens */\n    font-size: 22px;\n  }\n}\n\n@media (max-width: 480px) {\n  /* On very small screens, you might want to hide the user name */\n  .user-profile .user-name,\n  .user-profile .chevron-down {\n    display: none;\n  }\n  .header-controls {\n    gap: 16px; /* Reduce gap on small screens */\n  }\n}\n\n.profile-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n}\n\n.profile-trigger:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
